import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
    {
        path: "/",
        component: () => import('@/page/login.vue'),
    },
    {
        path: "/login",
        name: "login",
        component: () => import('@/page/login.vue'),
    },
    {
        path: "/index",
        name: "index",
        component: () => import('@/page/index.vue'),
    },
    {
        path: "/detail",
        name: "detail",
        component: () => import('@/page/detail.vue'),
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;
